import { Card, type CardProps } from '@mantine/core'
import { clsx } from 'clsx'
import React from 'react'

import { Item } from './Item'
import { ItemLabel } from './ItemLabel'
import { ItemValue } from './ItemValue'
import styles from './styles.module.css'

export type CardListProps = Omit<CardProps, 'variant'> & {
  variant?: 'space-between'
}

export function CardList({
  children,
  className,
  variant,
  ...props
}: CardListProps) {
  return (
    <Card
      {...props}
      withBorder
      className={clsx(styles.cardList, className, {
        [styles.cardListSpaceBetween]: variant === 'space-between',
      })}
    >
      {children}
    </Card>
  )
}

CardList.Item = Item
CardList.ItemLabel = ItemLabel
CardList.ItemValue = ItemValue
